import script from "./usage-rate.vue?vue&type=script&lang=ts&setup=true"
export * from "./usage-rate.vue?vue&type=script&lang=ts&setup=true"

import "./usage-rate.vue?vue&type=style&index=0&id=544ed6a0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544ed6a0"]])

export default __exports__